$(document).ready(function() {
  const $menu = $('header-menu');

  function checkAndToggleHoverClass() {
    if ($menu.attr('aria-expanded') === 'true') {
      $('body').addClass('hovered-menu');
    } else {
      $('body').removeClass('hovered-menu');
    }
  }

  // On mouse enter/leave
  $menu.on('mouseenter', checkAndToggleHoverClass);
  $menu.on('mouseleave', function() {
    $('body').removeClass('hovered-menu');
  });

  // Watch for aria-expanded changes
  const observer = new MutationObserver(checkAndToggleHoverClass);
  observer.observe($menu[0], {
    attributes: true,
    attributeFilter: ['aria-expanded']
  });


    var interval = setInterval(function() {
      var $widget = $('.template-product.inner-pages-ivyhome loox-snippets-widget');

      if ($widget.length > 0) {
        $widget.each(function() {
          $(this).attr('background-color', '#f4d5de');
          $(this).attr('text-color', '#981b31');
          $(this).attr('name-color', '#981b31');
          $(this).attr('rating-icon-color', '#981b31');
        });
      }
    }, 500);
});
